import { render, staticRenderFns } from "./InvoicesSuppliers.vue?vue&type=template&id=1863af6a&"
import script from "./InvoicesSuppliers.vue?vue&type=script&lang=js&"
export * from "./InvoicesSuppliers.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesSuppliers.vue?vue&type=style&index=0&id=1863af6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports